import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';

import { ErrorFormatter } from '../../../shared/formatter/error.formatter';
import { DoTrackInput } from '../../../shared/models/lead/doTrackInput.input';
import { LeadService } from '../../../shared/services/lead/lead.service';
import { ToastService } from '../../../shared/services/utils/toast.service';
import { LeadsComunicationService } from '../../leads/leads-comunication.service';
import { ModalsHandlerService } from '../modals.handler.service';

@Component({
  selector: 'ngx-on-track',
  templateUrl: './on-track-modal.component.html',
  styleUrls: []
})
export class OnTrackModalComponent implements OnInit, AfterViewInit {

  @ViewChild('content', { static: false }) content: Element;
  leadId: string;
  contactName: any;
  onTrackStatus: string;
  model: string;
  doTrackInput: DoTrackInput = new DoTrackInput();
  sending = false;
  comments: any;

  form: FormGroup;

  constructor(
    private readonly modalsHandler: ModalsHandlerService,
    private readonly modalService: NgbModal,
    private readonly leadService: LeadService,
    private readonly toasterService: ToastService,
    private readonly leadComuService: LeadsComunicationService,
    private readonly formBuilder: FormBuilder,
    private readonly spinner: NgxSpinnerService,
    private readonly errorFormatter: ErrorFormatter
  ) { }

  ngOnInit(): void {

    this.form = this.formBuilder.group({
      onTrackStatus: ['', Validators.required],
      comments: ['', Validators.required]
    });

  }

  get f(): any {
    return this.form.controls;
  }

  ngAfterViewInit(): void {
    this.resetForm();
    this.modalsHandler.trackLeadModal.subscribe(data => {

      this.doTrackInput.leadId = data.leadId;
      this.doTrackInput.onTrackStatus = data.onTrackStatus;
      this.modalService
        .open(this.content, {
          size: 'lg',
          container: 'nb-layout',
          ariaLabelledBy: 'modal-basic-title',
          backdrop: 'static', keyboard: false
        });
    });
  }

  onTrack(): void {

    this.spinner.show();

    if (this.form.invalid) {
      this.spinner.hide();

      return;
    }

    this.bindForm();

    this.leadService.doTrack$(this.doTrackInput).subscribe(() => {
      this.sending = true;
      this.modalService.dismissAll();
      this.leadComuService.launchReloadMyLead(this.doTrackInput.leadId);
      this.resetForm();
      this.toasterService
        .showToast(
          'success',
          'toaster.lead.on_track',
          'toaster.lead.status_on_track_changed'
        );
      this.spinner.hide();
      this.sending = false;
    }, error => {
      this.toasterService
        .showToast(
          'error',
          'Error',
          this.errorFormatter.formatErrors(error.graphQLErrors)
        );
      this.spinner.hide();
      this.sending = false;
      this.modalService.dismissAll();
      this.resetForm();
    });
  }

  resetForm(): void {
    this.doTrackInput.comments = '';
    this.doTrackInput.onTrackStatus = null;

    this.form.reset();
  }

  bindForm(): void {
    this.doTrackInput.onTrackStatus = this.f.onTrackStatus.value;
    this.doTrackInput.comments = this.f.comments.value;
  }
}
